module.exports = __webpack_public_path__ + "img/09.9f0aca7e.png";